import type { Question } from '@mentimeter/legacy-series-types/question';
import type { Slide as VotingSlide } from '../../compatibility-overrides/voting-types';
import type { CompatibilitySlide } from '../../compatibility-types';
import { handleNoInteractiveContentError } from '../../applications/common/handle-no-interactive-content-error';
import type { CommonQuestionProperty } from './get-common-question-property';

export const getQuestionWordcloudProperty = (
  target: CompatibilitySlide<'word-cloud'> | VotingSlide<'word-cloud'>,
  prop: keyof Question,
) => {
  const interactiveContent = target.interactiveContents?.[0];

  const staticContent = target.staticContent;
  const interactiveContentStyling = staticContent.interactiveContentStyling;

  if (prop === 'question_styled') {
    return staticContent.styledTitle ?? {};
  }

  if (interactiveContent) {
    switch (prop as keyof Omit<Question, CommonQuestionProperty>) {
      case 'max_nb_words':
        return interactiveContentStyling?.answersPerResponse;
      default:
        return undefined;
    }
  }

  return handleNoInteractiveContentError(target, prop);
};
